<template>
    <el-drawer
        title="导入题目"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel fx-g1" >
            <!--<el-form ref="form" :model="form" label-width="150px" class="edit_form"  >
                <el-form-item label="总部考试">
                    <el-select v-model="form.platformExamId" placeholder="总部考试">
                        <el-option
                            v-for="item in exams"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>-->
            <el-tabs>
                <div class="fx-g1" >
                    <el-table
                        :data="exams"
                        stripe
                        style="width: 100%"
                    >
                        <el-table-column
                            min-width="180"
                            prop="name"
                            label="总部考试" >
                        </el-table-column>

                        <el-table-column
                            label="操作"
                            min-width="240"
                        >
                            <template slot-scope="scope">
                                <el-button  v-repeatClick='3000' type="primary" size="mini" @click="sub(scope.row)">插入</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tabs>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <span  class="fx fx-center">
            <!--<el-button type="primary" @click="sub()">保 存</el-button>-->
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
        ],
        components: {
        },
        data() {
            return {
                show: false,
                needRefreshParent: false,
                form: {
                    ...this.item
                },
                exams: [],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
            }

        },
        methods: {
            close() {
                this.$emit("close");
            },
            sub(item) {
                console.log(item)
                //校验通过，干什么....
                this.$ajaxPost("/question/addByPlatformExamId", {
                    examId: this.form.id,
                    platformExamId: item.id
                }, (data) => {
                    this.$emit("submit", data.result);
                    this.showLoading = false;
                    this.needRefreshParent = true;
                    this.$showSuccess("保存成功");
                })
            },
            loadExams() {
                this.$ajaxPost("/exam/listByPlatform", {pager: {...this.pager, dataTotal: 0}},(data) => {
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.exams = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadExams();
            },
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadExams();
        }
    }
</script>
